// @core/api/endpoints/tag/bulk_tag_entities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkTagEntitiesRequest,
  BulkTagEntitiesResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Bulk tag entities
 * Assigns one or more tags to one or more entities in a single operation. Publishes individual tagged events for each assignment.
 */
export async function BulkTagEntities(
  data: BulkTagEntitiesRequest,
  options?: RequestOptions
): Promise<BulkTagEntitiesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags/bulk/assign`;
  const requestOptions = options;
  return client.post<BulkTagEntitiesResponse>(requestPath, data, requestOptions);
}
